<template>
  <div class="login-wrapper" @keyup.enter="submitForm">
    <div class="login">
      <img src="../../assets/images/logo.png" height="418" width="332"/>
      <el-form :model="formData" :rules="rules" ref="myForm" label-width="100px" class="my-form">
        <el-form-item label="用户名" prop="UserName">
          <el-input autofocus v-model="formData.UserName"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="UserPwd">
          <el-input show-password v-model="formData.UserPwd"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="login-btn" type="primary" @click="submitForm">登录</el-button>
    </div>
  </div>
</template>
<script>
import {postAction} from "../../service/http/api";
import des from '@/service/des'
import { mapActions } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      formData: {
        UserName: '',
        UserPwd: ''
      },
      rules: {
        UserName: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        UserPwd: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    ...mapActions({
      setUser: 'setUserInfo'
    }),
    submitForm () {
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          let fData = new FormData();
          fData.append('UserName',this.formData.UserName);
          fData.append('UserPwd',des.des_encrypt(this.formData.UserPwd));
          postAction('/login/authUser', fData).then(res => {
            if(res.code===200){
              let data = res.data;
              this.setUser(data.userName);
              localStorage.setItem('user',data.name||this.formData.UserName);//name用户昵称,userName登录用户名
              localStorage.setItem('userName',data.UserName||this.formData.UserName);
              localStorage.setItem('userKey',data.userKey);
              localStorage.setItem('token',data.userToken);
              localStorage.setItem('employeeId',data.employeeId);
              this.$router.push('/main');
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .login-wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    background: url("../../assets/images/bg.png") repeat;
    .login{
      position: absolute;
      top: calc(50% - 250px);
      right: 100px;
      width: 500px;
      height: 450px;
      background: linear-gradient(45deg, #2cd2fe, #5459ea);
      border-radius: 4px;
      .my-form{
        margin: auto;
        width: 90%;
      }
      img{
        display: block;
        margin: 50px auto 20px;
        width: 90px;
        height: 90px;
      }
      .login-btn{
        display: block;
        margin: 40px 180px 0;
        width: 150px;
        height: 40px;
        background: #45eafe;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue